import { COUNTRY_CURRENCIES } from "./country-currency";

const FRENCH_REGION_NAMES = new Intl.DisplayNames(["fr"], { type: "region" });

// Anciens libellés encore présents dans des CV et profils.
const COUNTRY_NAME_ALIASES: Readonly<Record<string, string>> = {
  congo: "CG",
  "republique democratique du congo": "CD",
};

export const getCountryName = (countryCode: string): string => {
  try {
    return FRENCH_REGION_NAMES.of(countryCode) ?? countryCode;
  } catch {
    return countryCode;
  }
};

// Insensible aux accents, à la casse, aux apostrophes et aux tirets.
export const normalizeCountryName = (name: string): string =>
  name
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/['’`]/g, "")
    .replace(/[\s-]+/g, " ")
    .trim()
    .toLowerCase();

export const findCountryCodeByName = (
  name: string,
  countryCodes: readonly string[] = Object.keys(COUNTRY_CURRENCIES),
): string | undefined => {
  const normalized = normalizeCountryName(name);

  if (!normalized) return undefined;

  return (
    countryCodes.find((code) => normalizeCountryName(getCountryName(code)) === normalized) ??
    countryCodes.find((code) => COUNTRY_NAME_ALIASES[normalized] === code)
  );
};
